import { mediaQuery, MENU_COLLAPSE_BREAKPOINT, ITheme } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const HEADER_HEIGHT = 80;
const MOBILE_HEADER_HEIGHT = 59;
const CMP_PADDING = 36;

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    container: {
      display: 'flex',
      position: 'relative',
      padding: [0, 0, 0, 0],
      flexDirection: 'column',

      [mediaQuery(breakpoints.tablet)]: {
        marginInline: 16,
      },
    },
    emojis: {
      margin: 0,
      padding: 0,
      listStyleType: 'none',
      gap: 6,

      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
    },
    category: {
      padding: [24, 0, 18, 0],
      fontStyle: 'normal',
      fontWeight: '700',
      fontSize: '20px',
      lineHeight: '28px',
      fontFeatureSettings: "'kern' off",
      color: '#121212',
      width: 'calc(100% - 130px)',

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        position: 'sticky',
        zIndex: 10,
      },
    },
  }),
  { name: 'Emojis' },
);
